export const bookingsRouteNames = {
  Booking: 'bookings/booking',
  BookingConfirmation: 'bookings/booking-confirmation',
  BookingNew: 'bookings/booking-new'
}
